import formatDate from 'date-fns/format';
import isDate from './isDateString';

const formatValue = (value) => isDate(value) ? formatDate(new Date(value), 'Pp') : value;

export default formatValue;
